import React from "react";
import styles from "../styles/sidebar.module.css";
import logo from "../assets/images/group.png";
import SideBarButton from "../store/containers/SideBarButtonContainer";
import { useLocation } from "react-router-dom";

const SideBar = ({ isAuthenticated }) => {
  const location = useLocation();

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <img src={logo} alt="logo" className={styles.logo}></img>
        <h1 className={styles.logoNormalText}>
          W<span className={styles.logoBoldText}>A</span>
        </h1>
      </div>
      {isAuthenticated ? (
        <SideBarButton
          title="Home"
          path="/rights"
          parentLoc={location.pathname}
        />
      ) : null}
      {/* {isAuthenticated ? (
        <SideBarButton
          title="Events"
          path="/events"
          parentLoc={location.pathname}
        />
      ) : null} */}
      <SideBarButton
        title="Privacy Policy"
        path="/privacy-policy"
        parentLoc={location.pathname}
      />
      {isAuthenticated ? (
        <SideBarButton
          title="Logout"
          path="/logout"
          parentLoc={location.pathname}
        />
      ) : null}
      {!isAuthenticated ? (
        <SideBarButton
          title="Login"
          path="/login"
          parentLoc={location.pathname}
        />
      ) : null}
    </div>
  );
};

export default SideBar;
